import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAppStore = defineStore('app', () => {
  // 状态
  const sidebarCollapsed = ref(false)
  const showTabs = ref(true)
  const systemVersion = ref('1.0.0')
  const themeMode = ref('light') // 'light' | 'dark'

  // 计算属性
  const isDark = computed(() => themeMode.value === 'dark')

  // 方法
  const setSidebarCollapsed = (collapsed) => {
    sidebarCollapsed.value = collapsed
    localStorage.setItem('sidebar_collapsed', collapsed.toString())
  }

  const toggleSidebar = () => {
    sidebarCollapsed.value = !sidebarCollapsed.value
    localStorage.setItem('sidebar_collapsed', sidebarCollapsed.value.toString())
  }

  // 主题切换
  // 深色模式的组件变量由 element-plus/theme-chalk/dark/css-vars.css 统一提供，
  // 这里只切换 html.dark 类，不再内联注入变量（旧变量表与官方文件存在错位，会干扰组件渲染）
  const setTheme = (mode) => {
    themeMode.value = mode
    const html = document.documentElement
    const isDark = mode === 'dark'

    // 切换 Element Plus 深色模式类
    html.classList.toggle('dark', isDark)

    localStorage.setItem('theme', mode)
  }

  const toggleTheme = () => {
    setTheme(themeMode.value === 'dark' ? 'light' : 'dark')
  }

  const initTheme = () => {
    const savedTheme = localStorage.getItem('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const mode = savedTheme || (prefersDark ? 'dark' : 'light')
    setTheme(mode)
  }

  return {
    // 状态
    sidebarCollapsed,
    showTabs,
    systemVersion,
    themeMode,

    // 计算属性
    isDark,

    // 方法
    setSidebarCollapsed,
    toggleSidebar,
    setTheme,
    toggleTheme,
    initTheme
  }
})